import React, { useEffect, useContext, useState } from "react"
import { SectionContext } from "../context/sectionContext"
import { ConditionContext } from "../context/conditionContext"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper.min.css"
import { JourneyContext } from "../context/journeyContext"
import "swiper/components/navigation/navigation.min.css"
import SwiperCore, { Navigation } from "swiper/core"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import { lineCapital } from "../../shared/functions"
import { productRenderChecker, getValueFromJourney, DataLayerIntegration } from "../services/helperFunctions"
import * as keywordMapping from "../../../static/nvestKeyMapping.json"
import ComponentReadMore from "./componentReadMore"
import Parser from 'html-react-parser';



SwiperCore.use([Navigation])

const radioCardFormControlKey = [
  "CPCustomizePlanQuestionOne",
  "iSelect360CPCustomizePlanQuestionOne",
  "CPChooseYourPlan",
  "CPOptionInBuilt",
  "CPSpouseOptionBuilt",
]

export default function ComponentCheckboxFormGroup(props) {
  const [activeTab, setActiveTab] = useState(
    props.data.checkboxComponent[0].name
  )
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [options, setOptions] = useState({})
  const [readMoreExpandObj, setReadMoreExpandObj] = useState([false,false,false,false,false,false,false,false])
  const [journeyState, setJourneyState] = useContext(JourneyContext)

  // const [toggleCheck, setToggleCheck] = useState(false)

  let arr = {}
  // let toggleCheck = false
  useEffect(() => {
    if(sectionState.sectionData && Object.keys(sectionState.sectionData)?.length > 0){
      if(sectionState.sectionData[props.data.formControlKey]){
        // let currentRadio = document
        // .getElementById(sectionState.sectionData[props.data.formControlKey])?.querySelector("[data-active-class]")
        // console.log("currentRadio",currentRadio)
        // console.log("parent",currentRadio.parentElement.parentElement)
        // if(currentRadio){
        //   if (sectionState.sectionData[props.data.formControlKey]) {
        //     currentRadio.parentElement.parentElement.classList.add("active")
        //   } else {
        //     currentRadio.parentElement.parentElement.classList.remove("active")
        //   }
        // }
      }else{
        setConditionState(prev => {
          return ({
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
          })
        })
      }
    }
  }, [sectionState.sectionData?.[props.data.formControlKey], options[props.data.formControlKey]])

  useEffect(() => {
    let optionsFromStrapi = props.data.checkboxComponent
    let planOptionList = []
    if(props.data.formControlKey === "iSelect360CPOptionInBuiltATPD" && journeyState.journeyIdFromStrapi === "ISelect360Journey"){
      props.data.checkboxComponent?.forEach(element => {
        console.log(element, props.data.checkboxComponent[element])
        Object.keys(journeyState.planOptionList).forEach(optionList => {
          if(optionList == element.value){
            planOptionList.push(element)
          }
        })
      })
      optionsFromStrapi = planOptionList
    }
    console.log(props.nvestFilterResult, "dfdfefe")
    let optionNameInMappingJson = keywordMapping[props.journeyIdFromStrapi][`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]
    let requiredObjectInNvestFilterResult = props.nvestFilterResult?.formInputs.filter(element => element.unified_keywordName === optionNameInMappingJson)
    if(!requiredObjectInNvestFilterResult || !optionNameInMappingJson){
      setOptions(prev => {
        return ({
          ...prev,
          [props.data.formControlKey]: optionsFromStrapi
        })
      })
      return 
    }
    let parentUnifiedkeyofProposalJSON = requiredObjectInNvestFilterResult?.[0]?.listItems?.[0]?.ParentUnifiedkeyofProposalJSON
    //reverseMapping the value
    if(parentUnifiedkeyofProposalJSON){
      
        let reverseKey = Object.keys(keywordMapping[props.journeyIdFromStrapi]).find(element => 
          {
            if(typeof keywordMapping[props.journeyIdFromStrapi][element] === "string"){
              let keyInNvestToCheck
              if(parentUnifiedkeyofProposalJSON.includes(",")){
                  let temp = parentUnifiedkeyofProposalJSON.split(",")
                  keyInNvestToCheck = temp[0]
              }else{
                  keyInNvestToCheck = parentUnifiedkeyofProposalJSON
              }
              return keywordMapping[props.journeyIdFromStrapi][element].toLowerCase() === keyInNvestToCheck.trim().toLowerCase()
            }
          })
        if(reverseKey){
            if(conditionState[reverseKey]){
                let newOptions = []
                requiredObjectInNvestFilterResult?.[0]?.listItems?.map((element, index) => {
                    if(productRenderChecker(element.ParentUnifiedCode,conditionState[reverseKey])){
                        let option = optionsFromStrapi[index]
                        if(option){
                          newOptions.push(option)
                        }
                       
                    }
                })
                // console.log(newOptions, "fgfg")
                setOptions(prev => {
                  return ({
                    ...prev,
                    [props.data.formControlKey]: newOptions
                  })
                })
            }else{
              setOptions(prev => {
                return ({
                  ...prev,
                  [props.data.formControlKey]: []
                })
              })
              setConditionState(prev => {
                return {
                  ...prev,
                  [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
                }
              })
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [props.data.formControlKey]: ""
                  }
                }
              })
            }
        }else{
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
            }
          })
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: ""
              }
            }
          })
        }
    }else{
      let newOptions = []
      requiredObjectInNvestFilterResult?.[0]?.listItems?.map((element, index) => {
          let option = optionsFromStrapi[index]
          if(option){
            newOptions.push(option)
          }
      })
      // console.log(newOptions, "product is null")
      setOptions(prev => {
        return ({
          ...prev,
          [props.data.formControlKey]: newOptions
        })
      })
    }
  }, [props.nvestFilterResult, conditionState?.[props.watchKey]])

  const createCardSet = () => {
    let cardContainers = document.querySelectorAll(".radio-card-container")

    cardContainers.forEach(cardContainer => {
      cardContainer.querySelectorAll("[data-active-class]").forEach(el => {
        let dataActiveClass = el.getAttribute("data-active-class")
        if (arr[dataActiveClass]) {
          arr[dataActiveClass] = [...arr[dataActiveClass], el]
        } else {
          arr[dataActiveClass] = [el]
        }
      })
    })

    // console.log("data-active-class",arr);

    let selectors = [
      '#myBtn',
      '#myBtn1',
      '#myBtn2',
      '#myBtn3',
      '#myBtn4',
      '#myBtn5'
    ]

    let readMoreObj = {}
    selectors.forEach((i,index)=>{

      readMoreObj[`el${index}`] = {element:document.querySelector(i)}

      if(readMoreObj[`el${index}`].element) {
          let parent = readMoreObj[`el${index}`].element.parentElement
          if(parent){
            readMoreObj[`dots${index}`] = parent?.querySelector(`#dots${index>0?index:''}`)
            readMoreObj[`more${index}`] = parent?.querySelector(`#more${index>0?index:''}`)
            readMoreObj[`readMoreContent${index}`] = parent?.querySelector(`.readmore-content${index>0?index:''}`)
          }   
      }
    })

    selectors.forEach((i,index)=>{
      if(readMoreObj[`el${index}`].element) {
        readMoreObj[`el${index}`].element?.addEventListener('click',(e)=>{
          // console.log("event",e);
          // e.stopPropagation();
          // e.bubbles = false;
          e.preventDefault()
          let tempArr = readMoreExpandObj
          tempArr[index]=!readMoreExpandObj[index]
          setReadMoreExpandObj((prev)=>{
            return tempArr
          })

          console.log(readMoreExpandObj);
          

            readMoreObj[`more${index}`].style.display =  readMoreExpandObj[index]? "inline" :"none"
            readMoreObj[`el${index}`].element.textContent =  readMoreExpandObj[index] ? "Read less":'Read more'
            readMoreObj[`dots${index}`].style.display = readMoreExpandObj[index]? "none" :"block"  
        })
      }
    })


  }
  createCardSet()

  const handleEnter = (event1,event2,isCard) =>{
    handleChange(event1,event2, isCard)

  }

  const handleChange = (e,{ target }, isCard) => {
    if((props?.sectionId === "iSelect360CPOptionalInBuilt" || props?.sectionId === "iSelect360CPSpouseCoverDetails" || props?.sectionId === "P2PCPOptionalInBuilt" || props?.sectionId === "P2PCPSpouseCoverDetails") && target){
      let eventName = ""
      let formControlKey = "optionalInBuilt"
      let value = [props.data.formControlKey, (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey] === target.value) ? "" : target.value]
      let journeyFormatData = props.applicationDataInJourneyFormat(value)
      DataLayerIntegration(journeyFormatData, eventName, props?.sectionId, formControlKey, journeyState)
    }
    console.log(props.journeyDataState);
    e?.preventDefault();
    // console.log(toggleCheck)
    let previousSelectedValue = sectionState.sectionData?.[props.data.formControlKey] || ""
    if (sectionState.sectionId === props.sectionId) {
      if(sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey] === target.value ){
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: "",
            },
          }
        })
      }else{
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: target.value,
            },
          }
        })
      }
    } else {
      if(sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] === target.value){
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: "",
            },
          }
        })
      }else{
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: target.value,
            },
          }
        })
      }
      
    }
    if(conditionState[`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`] && conditionState[`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`] === target.value){
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
        }
      })
    }else{
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: target.value,
        }
      })
    }
    if(props.saveApplicationAndCallBi){
      if(props.data.formControlKey === "iSelect360CPOptionInBuiltATPD" && (target.value === "ICATP2" || target.value === "IXATP2")){
        if(sectionState.sectionData["iS360sumAssuredATPD2"]){
          props.saveApplicationAndCallBi(props.data.formControlKey, (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey] === target.value) ? "" : target.value)
        }
      }else if(props.data.formControlKey === "iSelect360CPSpouseOptionInBuiltATPD" && (target.value === "ICATP4" || target.value === "IXATP4")){
        if(sectionState.sectionData["iS360SpouseSumAssuredATPD2"]){
          props.saveApplicationAndCallBi(props.data.formControlKey, (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey] === target.value) ? "" : target.value)
        }
      }else{
        props.saveApplicationAndCallBi(props.data.formControlKey, (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey] === target.value) ? "" : target.value, previousSelectedValue)
      }
    }
    // console.log(toggleCheck)
    // setToggleCheck(true)
    // console.log(toggleCheck)
    if (target.value && isCard) {
      console.log(target.value)
      // console.log(target.value);
      // smoke-white-clr
      // console.log(target.parentElement.parentElement.parentElement)

      // radio-cards by Id
      let currentRadio = document
        .getElementById(target.value)
        .querySelector("[data-active-class]")
      // console.log(currentRadio)
      // let parent = currentRadio.parentElement.querySelectorAll(".radio-card")

      // removing other active class
      let radios = arr[currentRadio.getAttribute("data-active-class")]
      // console.log(radios);
      
      radios?.forEach(radio => {
        radio.classList.remove("active")
      })

      // activate radio Radio
      // if (!sectionState.sectionData[props.data.formControlKey]) {
      //   currentRadio.classList.add("active")
      // } else {
      //   currentRadio.classList.remove("active")
      // }
      // setToggleCheck(!toggleCheck)
      // console.log(toggleCheck,"svsv");
    }

    console.log(sectionState, "section state")
    // console.log(conditionState, "condition state")
  }
  return (options[props.data.formControlKey] && options[props.data.formControlKey].length >= 1 ?
    <div className={`field ${props.elementClass}`} key={props.sectionId + props.indexForKey}>
      <style>
        {`
        .radio-tab {
          display: flex;
          justify-content:space-evenly;
          margin-bottom:2rem;
          border:1px solid black;
        }
        .radio-tab > *{
          color:black;
          background:transparent;
          padding:0;
          flex:1;
          padding: 4px 0;

        }

        .radio-tab p{
          margin:0;
          
        }

        .active-tab{
          background-color: ${props.channel === "A" ? "#000000" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"};
          background-color: var(--lumiq-secondary);
          color:white
        }
        .card-label {
          height:3rem;
          text-align:center;
          font-weight:bold;
        }

        
          .tick{
            position:relative;
            top:5rem;
            left:2rem;
            z-index:1;
          }           
          
          .check11{
            display:none !important  
          }


          .ridersOptionSection .tick {
            top: 45px !important;
            left: 20px !important;
          }
          #ICBYP1 .checkbox-card > div{
            position:relative;

          }

          #ICBYP1 .checkbox-card > div input[type="radio"]{
            display:none;
          }
          #IXBYP1 .checkbox-card > div{
            position:relative;
          }
          #IXBYP1 .checkbox-card > div input[type="radio"]{
            display:none;
          }
          @media screen and (max-width:992px) {
            .ridersOptionSection .h132{
              font-size:14px !important;
             line-height:1.2rem;
            }
           .ridersOptionSection .tick {
             top: 45px !important;
             left: 20px !important;
            }
          }
          @media screen and (max-width:767px){
            .ridersOptionSection .tick{
              top: 40px !important;
              left: 10px !important;
            }
          }


          .ridersOptionSection .h132{
             font-size:14px !important;
            line-height:1.2rem;
         }
         
         .removeborder .by-pay{
          display:none;
         }
         .iselect-box-design .row  .option-buit-design-new-new-design::after {
          height: 8rem;
         }
         @media screen and (max-width:992px){
           .row.radio-card-container.ridersOptionSection .radio-card{
            width:100% !important;
           }
          .width100rider .field2-grid,
          .width100rider .field2,
          .width100rider .field{
            width:100% !important;
            margin-bottom: -19px;
          }
          
          .col-md-9{
            width:100% !important;
          }
         }
      
   

        `}
      </style>
      <div className="row radio-card-container ridersOptionSection">
        {options[props.data.formControlKey] && options[props.data.formControlKey].length >= 1 && options[props.data.formControlKey].map((element, i) => {
          return (
            <div
              className={`radio-card ${element.class}`}
              key={i}
              name={element.name}
              id={element.value}
              checked={
                sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]
                  ? sectionState.sectionData[props.data.formControlKey] ===
                    element.value
                  : element.checked
              }
              tabIndex="0"
              onKeyPress={(e)=>handleEnter(e,{ target: { value: element.value } }, true)}


            >
             
            <span
              style={{
                opacity:
                (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] ===
                  element.value || element.checked )
                  ? "1"
                  : "0",
                }}
                aria-hidden="true"
                className="tick"
                onClick={e =>
                  handleChange(e,{ target: { value: element.value } }, true)
                }
                >
                <FaCheck />
            </span>
              <div style={{
                "background-color": "#fff",
                "box-shadow": "0px 0px 10px #ccc",
                "border-radius": "10px",
                "padding": "20px 0px",
                "float": "left",
                "width": "100%",
                // "margin-bottom": "30px",
                "height": "172px",
              }} className={`${"checkbox-card"} removeborder ${
                (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] ===
                  element.value || element.checked )
                  ? "active"
                  : ""
              }`} >

                <div  dangerouslySetInnerHTML={{ __html: element.html }} />
                <div className="h132 as" style={{
                      "width": "80%",
                      "margin-left": "17%",
                      "line-height": "1.8",
                      "fontSize":"1.1rem",
                }} >                               
                  { element.nonReadmore && Parser(element.nonReadmore) }                     
              { element.readmore &&
              <ComponentReadMore html={element.readmore} index={element.identifier} style={{color:"inherit"}}/>
              }
                </div>
              </div>
              <div aria-hidden="true" onClick={e =>
                handleChange(e,{ target: { value: element.value } }, true)
              } className="check-container"></div>
            </div>
          )
        })}
      </div>
    </div>
    :
    <>
    </>
  )
}
